import { OrganizationMember } from '@prisma/client'
import { Api } from '~/core/trpc'

type Props = {
  organizationMember: OrganizationMember
}

type PublishPostOptions = {
  blogPostId: string
  providerAccountId: string
}

type FindUserInformationOptions = {
  providerAccountId: string
}

export const useWordpressSdk = ({ organizationMember }: Props) => {
  const publishPostMutation = Api.dataConnector.actionRun.useMutation()

  const findUserInformation = async (options: FindUserInformationOptions) => {
    const { response } = await publishPostMutation.mutateAsync({
      providerKey: 'wordpress',
      providerActionKey: 'findUserInformation',
      providerAccountId: options.providerAccountId,
      organizationMemberId: organizationMember.id,
      args: {
        providerAccountId: options.providerAccountId,
      },
    })

    return { response }
  }

  const publishPost = async (options: PublishPostOptions) => {
    const { response } = await publishPostMutation.mutateAsync({
      providerKey: 'wordpress',
      providerActionKey: 'publishPost',
      providerAccountId: options.providerAccountId,
      organizationMemberId: organizationMember.id,
      args: {
        blogPostId: options.blogPostId,
      },
    })

    return { response }
  }

  return { publishPost, findUserInformation }
}
